export default __webpack_public_path__ + "static/media/Snd_TryG.b2e369a5.mp3";